import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetProdCategory/Main";
import Form from "./TbSetProdCategory/Form";

// Utils
import { getDataWithComp, getAlert } from "../../../utils/SamuiUtils";

const TbSetProdCategory = () => {
    const [mode, setMode] = useState("");
    const [dataMasterList, setDataMasterList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [formData, setFormData] = useState({ ProdCat_Id: 0, ProdCat_Name: "", ProdCat_Status: "Y", comp_id: null });

    useEffect(() => {
        initialize();
    }, []);

    const initialize = async () => {
        try {
            setMode("S");
            fetchRealtime();
        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

    const fetchRealtime = async () => {
        try {
            const masterList = await getDataWithComp("Tb_Set_ProdCategory", "Order By ProdCat_Id");
            if (masterList && masterList.length > 0) {
                setDataMasterList(masterList);
            } else {
                setDataMasterList([]);
            }
        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

    const onPageInsert = () => {
        setMode("I");
    };

    const onRowSelected = (item) => {
        setMode("U");
        setFormData({
            comp_id: item.Comp_Id,
            ProdCat_Id: item.ProdCat_Id,
            ProdCat_Name: item.ProdCat_Name,
            ProdCat_Status: item.ProdCat_Status,
        });
        setSelectedData(item);
    };

    return (
        <div className="TbSetProdCategory">
            <div className="wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="container">
                        <div className="page-inner">
                            <div style={{ display: mode === "S" ? "block" : "none" }}>
                                <Main
                                    masterList={dataMasterList}
                                    name={"ข้อมูลหมวดหมู่สินค้า"}
                                    onPageInsert={() => onPageInsert()}
                                    onRowSelected={(item) => onRowSelected(item)}
                                />
                            </div>
                            <div style={{ display: mode !== "S" ? "block" : "none" }}>
                                <Form
                                    callInitialize={initialize}
                                    mode={mode}
                                    name={"ข้อมูลหมวดหมู่สินค้า"}
                                    formData={formData}
                                    setFormData={setFormData}
                                    selectedData={selectedData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TbSetProdCategory;
